<template>
  <el-dialog
    title="课程学情"
    :visible.sync="dialogVisible"
    width="700px"
    :close-on-click-modal="false"
    :before-close="handleClose"
    class="dialog-container"
  >
    <div>
      <p class="info-box">
        课程名：<span>{{ usageInfo.goods_title }}</span>
      </p>
      <p class="info-box">
        课程ID：<span>{{ usageInfo.course_id }}</span>
      </p>
      <!-- <p class="info-box">详细学习记录：已学课时占比{{ usageInfo.study_lesson }} / {{ usageInfo.total_lesson }} ≈ <span>{{
        formatNumber(usageInfo.study_lesson / usageInfo.total_lesson * 100) }}%</span>，
        未学占比<span>{{ 100 - formatNumber(usageInfo.study_lesson / usageInfo.total_lesson * 100) }}%</span></p> -->
      <div class="export-btn" @click="exportTable">导出表格</div>
      <el-table :data="tableData" style="width: 100%" border height="400px">
        <el-table-column
          type="index"
          label="序号"
          :index="indexMethod"
          width="60"
        />
        <el-table-column prop="unit_name" label="单元名" width="180" />
        <el-table-column prop="lesson_name" label="课时名" width="180">
          <template slot-scope="scope">
            <div>
              <p>{{ scope.row.lesson_name || "-" }}</p>
              <el-tag
                v-if="scope.row.lesson_type === 1"
                size="small"
                :type="getType(scope.row.lesson_type)"
                >{{ "点播" }}</el-tag
              >
              <el-tag
                v-else-if="scope.row.lesson_type === 2"
                size="small"
                :type="getType(scope.row.lesson_type)"
                >{{ "直播" }}</el-tag
              >
              <el-tag
                v-else-if="scope.row.lesson_type === 3"
                size="small"
                :type="getType(scope.row.lesson_type)"
                >{{ "作业" }}</el-tag
              >
              <el-tag
                v-else-if="scope.row.lesson_type === 4"
                size="small"
                :type="getType(scope.row.lesson_type)"
                >{{ "私教课" }}</el-tag
              >
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="live_start_time" label="课时信息">
          <template slot-scope="scope">
            <div v-if="scope.row.lesson_type === 3">-</div>
            <div v-else>
              {{
                scope.row.lesson_type === 1
                  ? formatTime(scope.row.duration)
                  : formatTime(
                      scope.row.live_end_time - scope.row.live_start_time
                    )
              }}
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="study_status" label="学习记录">
          <template slot-scope="scope">
            <div>{{ scope.row.study_status ? "已学习" : "未学习" }}</div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button size="small" type="primary" @click="handleClose"
        >关 闭</el-button
      >
    </span>
  </el-dialog>
</template>

<script>
import { mapGetters } from "vuex";
import { saveAs } from "file-saver";
import { utils, write } from "xlsx";
import { getLookList } from "@saas/server-api/src/learning-center";
import { downloadFileByWindowOpen } from "@saas/components";
export default {
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    data: {
      type: Object,
      default: () => ({}),
    },
    type: {
      type: String,
      default: "refund",
    },
  },
  data() {
    return {
      dialogVisible: false,
      usageInfo: {},
      tableData: [],
    };
  },
  computed: {
    ...mapGetters(["user"]),
  },
  watch: {
    visible(val) {
      this.dialogVisible = val;
      if (val) {
        this.usageInfo = this.data || {};
        this.tableData = [];
        this.getData();
      }
    },
  },
  methods: {
    getType(type) {
      if (type === 1) {
        return "";
      } else if (type === 2) {
        return "success";
      } else if (type === 3) {
        return "warning";
      } else {
        return "";
      }
    },
    // 保留一位小数，向下取整
    formatNumber(num) {
      return Math.floor(num * 10) / 10;
    },
    formatTime(milliseconds) {
      const totalSeconds = Math.floor(milliseconds);
      const hours = Math.floor(totalSeconds / 3600);
      const minutes = Math.floor((totalSeconds % 3600) / 60);
      const seconds = totalSeconds % 60;

      return `${hours.toString().padStart(2, "0")} 时 ${minutes
        .toString()
        .padStart(2, "0")} 分 ${seconds.toString().padStart(2, "0")} 秒`;
    },
    indexMethod(index) {
      return index + 1;
    },
    getData() {
      getLookList({
        course_id: this.usageInfo.course_id,
        user_id:
          this.type === "refund"
            ? this.usageInfo.apply_user_id
            : this.usageInfo.user_id,
      })
        .then((res) => {
          const { code, data } = res;
          if (code === 1) {
            this.tableData = data || [];
          }
        })
        .catch((err) => {
          console.error("获取看课记录失败>>>", err);
        });
    },

    handleClose() {
      this.$emit("close");
    },
    exportTable() {
      if (this.tableData && this.tableData.length) {
        this.exportUsageData();
      } else {
        this.$message.error("无数据");
      }
    },
    exportUsageData() {
      downloadFileByWindowOpen(
        `${process.env.VUE_APP_ADMIN_API}/v1/userCourse/exportCourseProgress`,
        {
          course_id: this.usageInfo.course_id,
        }
      );
      //   //   从列表数据中提取需要导出的字段
      //   const dataToExport = this.tableData.map((usageInfo) => ({
      //     单元名: usageInfo.unit_name,
      //     课时名: usageInfo.lesson_name,
      //     课时类型: usageInfo.lesson_type === 1 ? "点播" : "直播",
      //     课时信息:
      //       usageInfo.lesson_type === 1
      //         ? this.formatTime(usageInfo.duration)
      //         : this.formatTime(
      //             usageInfo.live_end_time - usageInfo.live_start_time
      //           ),
      //     学习记录: usageInfo.study_status ? "已学习" : "未学习",
      //     // 添加其他需要导出的字段
      //   }));
      //   //   创建工作簿、工作表等，与之前示例相同
      //   const workbook = utils.book_new();
      //   const worksheet = utils.json_to_sheet(dataToExport);
      //   utils.book_append_sheet(workbook, worksheet, "Sheet1");
      //   // 写入二进制数据、创建Blob对象、保存文件
      //   const excelData = write(workbook, { type: "array" });
      //   const blob = new Blob([excelData], { type: "application/octet-stream" });
      //   saveAs(blob, this.usageInfo.goods_title + "_使用详情.xlsx");
    },
  },
};
</script>

<style lang="scss" scoped>
.dialog-container {
  ::v-deep {
    .el-dialog__body {
      padding-top: 0;
    }
  }
}

.info-box {
  line-height: 38px;
}

.export-btn {
  float: right;
  width: 80px;
  height: 34px;
  line-height: 32px;
  text-align: center;
  cursor: pointer;
  color: $blue-color;
}
</style>
